












import { Settings } from "@/types/settings";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class SettingsChangeClusters extends Vue {
  @Getter("settings/activeCacheSettings") settings!: Settings;

  title = "Change Clusters";

  changeClusters() {
    if (
      window.confirm(
        "This will move your cache to a different cluster. As a result all data from your cache will be lost. Are you sure you want to do this?",
      )
    ) {
      this.$ga.button(this.title);
      this.$store.dispatch("switchCluster");
    }
  }
}
